module.exports = __webpack_public_path__ + "static/media/PaternityLeave.332540ac.svg";